// Under an agent's reply: "Sources:" and a chip for every record the reply named or its run used (its
// refs, resolved for the viewer by the agent detail). The ones the reply names come first. At most 8
// show; "+N more" shows the rest, and "Show fewer" folds them again (one button, so focus stays on it).
// A reply with no ref it can show has no row: one from before sources were kept, or one that named and
// used no record of a kind that is linked.
//
// Props: refs (the message's refs); onOpen(ref): a chip was pressed.
import React, { useState } from 'react';
import SourceChip from './SourceChip';
import { refItems } from './refKinds';

const SHOWN = 8;

const ROW = 'mt-1.5 flex items-start gap-1 text-[11px]';
const WORD = 'shrink-0 py-0.5 leading-4 text-slate-500 dark:text-slate-400';
const LIST = 'list-none m-0 p-0 flex min-w-0 flex-wrap items-center gap-1';
const ITEM = 'max-w-full min-w-0';
const MORE = 'py-0.5 leading-4 text-[11px] text-slate-500 dark:text-slate-400 hover:underline';

export default function SourcesRow({ refs, onOpen = null }) {
  const [all, setAll] = useState(false);
  const items = refItems(refs);
  if (!items.length) return null;
  const ordered = [...items.filter((item) => item.mentioned === true), ...items.filter((item) => item.mentioned !== true)];
  const shown = all ? ordered : ordered.slice(0, SHOWN);
  const rest = ordered.length - SHOWN;
  return (
    <div className={ROW}>
      <span className={WORD}>Sources:</span>
      <ul aria-label="Sources" className={LIST}>
        {shown.map((item) => (
          <li key={item.key} className={ITEM}><SourceChip item={item} onOpen={onOpen} /></li>
        ))}
        {rest > 0 && (
          <li>
            <button type="button" aria-expanded={all} onClick={() => setAll((now) => !now)} className={MORE}>
              {all ? 'Show fewer' : `+${rest} more`}
            </button>
          </li>
        )}
      </ul>
    </div>
  );
}
